module.exports = __webpack_public_path__ + "static/img/icon_admin absensi.4496cbd2.svg";